import sdkProvider from "./sdkProvider";

const activateMvtFeature = async ({ featureName, audience }) => {
  const sdk = await sdkProvider("features");
  await sdk.onReady();

  sdk.getFeature(featureName, null, audience).isEnabled();
};

export default activateMvtFeature;
